var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proxy-bar"},[_c('global-alert',[_vm._v(" "+_vm._s(_vm.$t("account-outstanding"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }